import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  Milk, 
  Mail, 
  Phone, 
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Youtube,
  Heart
} from 'lucide-react';
import '../../../assets/styles/customer/components/MyFooter.css';

const MyFooter = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: 'Pricing', href: '#pricing' },
      { name: 'About', href: '#about' },
      { name: 'Contact', href: '#contact' }
    ],
    forUsers: [
      { name: 'Customer Signup', href: '#customer-signup' },
      { name: 'Login', href: '#login' }
    ],
    forDistributors: [
      { name: 'Become a Distributor', href: '#become-distributor' },
      { name: 'Distributor Login', href: '#distributor-login' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '#privacy' },
      { name: 'Terms of Service', href: '#terms' },
      { name: 'Cookie Policy', href: '#cookies' }
    ]
  };

  const socialLinks = [
    { icon: <Facebook size={20} />, href: '#', name: 'Facebook' },
    { icon: <Twitter size={20} />, href: '#', name: 'Twitter' },
    { icon: <Instagram size={20} />, href: '#', name: 'Instagram' },
    { icon: <Linkedin size={20} />, href: '#', name: 'LinkedIn' },
    { icon: <Youtube size={20} />, href: '#', name: 'YouTube' }
  ];

  return (
    <footer className="footer">
      
      {/* Main Footer Content */}
      <div className="footer-main">
        <Container>
          <Row className="g-4">
            
            {/* Brand Column */}
            <Col lg={4} md={6} sm={12}>
              <div className="footer-brand">
                <div className="footer-logo">
                  <div className="footer-logo-icon">
                    <Milk size={28} />
                  </div>
                  <span className="footer-logo-text">MilkyWay</span>
                </div>
                <p className="footer-tagline">
                  Simplifying dairy delivery management for Pakistan's local milk supply chain.
                </p>
                
                {/* Contact Info */}
                <div className="footer-contact">
                  <div className="contact-item">
                    <Mail size={18} />
                    <a href="mailto:info@milkflow.pk">info@milkflow.pk</a>
                  </div>
                  <div className="contact-item">
                    <Phone size={18} />
                    <a href="tel:+923001234567">+92 300 1234567</a>
                  </div>
                  <div className="contact-item">
                    <MapPin size={18} />
                    <span>Gujranwala, Punjab, Pakistan</span>
                  </div>
                </div>
              </div>
            </Col>

            {/* Product Links */}
            <Col lg={2} md={6} sm={6} xs={6}>
              <div className="footer-column">
                <h3 className="footer-column-title">Product</h3>
                <ul className="footer-links">
                  {footerLinks.product.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* For Users Links */}
            <Col lg={2} md={6} sm={6} xs={6}>
              <div className="footer-column">
                <h3 className="footer-column-title">For Users</h3>
                <ul className="footer-links">
                  {footerLinks.forUsers.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* For Distributors Links */}
            <Col lg={2} md={6} sm={6} xs={6}>
              <div className="footer-column">
                <h3 className="footer-column-title">For Distributors</h3>
                <ul className="footer-links">
                  {footerLinks.forDistributors.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Legal Links */}
            {/* <Col lg={2} md={6} sm={6} xs={6}>
              <div className="footer-column">
                <h3 className="footer-column-title">Legal</h3>
                <ul className="footer-links">
                  {footerLinks.legal.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </Col> */}

          </Row>

          {/* Social Links */}
          <div className="footer-social">
            <h3 className="social-title">Follow Us</h3>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.href}
                  className="social-link"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

        </Container>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <Container>
          <Row className="align-items-center">
            <Col md={6} sm={12}>
              <p className="footer-copyright">
                © {currentYear} MilkFlow. All rights reserved.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <p className="footer-made-with">
                Made with <Heart size={16} fill="#f44336" color="#f44336" className="heart-icon" /> for Pakistan's dairy community
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Floating Decoration */}
      <div className="footer-decoration">
        <div className="decoration-bottle">🥛</div>
      </div>

    </footer>
  );
};

export default MyFooter;